window.addEventListener("load", () => {
    // Add sticky emulation for Hero ATC
	let stickyCTA = document.querySelector('.cta-qa');

	if (stickyCTA && window.innerWidth <= 992) {
		const target = document.getElementsByClassName('product-form__buttons')[0];
        let options = {
            root: null,
            rootMargin: "60px 0px",
            threshold: 0,
        };

		let callback = (entry, observer) => {
            if (entry[0].isIntersecting) {
                el = entry[0].target;
				stickyCTA.classList.remove('cta-qa--active');
            } else {
				stickyCTA.classList.add('cta-qa--active');
            }
        };

		let observer = new IntersectionObserver(callback, options);
        observer.observe(target);
	}

	let loyalitySlide = document.querySelector('.PdpHero-loyalty');

    if (loyalitySlide) {
        let buttons = document.querySelectorAll('.PdpHero-options label');
        let paragraphs = document.querySelectorAll('.PdpHero-loyalty');

        buttons.forEach((button, index) => {
            button.addEventListener('click', function() {
				paragraphs.forEach(paragraph => {
					paragraph.classList.remove('loyalty_variant_show');
				});
				paragraphs[index].classList.add('loyalty_variant_show');
            });
        });
    }
}, false);